<script setup lang="ts">
	const { gsap } = useGSAP()

	const $props = defineProps<{
		items: Array<NavigationItem>,
	}>()

	const overlay = ref(null)
	const active = ref(false)
	let hoverTween

	const show = () => {
		if (hoverTween) hoverTween.kill()
		hoverTween = gsap.to(overlay.value, { height: '100vh', duration: 1, ease: 'power4.inOut' })
		active.value = true
	}
	const hide = () => {
		if (hoverTween) hoverTween.kill()
		hoverTween = gsap.to(overlay.value, { height: 0, duration: 0.4, ease: 'power4.inOut' })
		active.value = false
	}

	onMounted(() => {
		gsap.set(overlay.value, { height: 0, transformOrigin: 'top center' })
	})

	const route = useRoute()
	watch(() => route.fullPath, () => {
		hide()
	})
</script>

<template>
	<div class="my-auto">
		<LayoutBtnToggle @click="show"></LayoutBtnToggle>
		<div ref="overlay" class="absolute left-0 top-0 w-full h-screen z-5 overflow-hidden bg-white">
			<div class="relative h-full w-full">
				<button @click="hide" aria-label="Navigation schliessen" class="absolute right-10 top-5 xl:right-15 xl:top-7 2xl:right-20 2xl:top-10 group cursor-pointer">
					<GsIcon name="material-symbols-close" class="size-8 md:size-10 xl:size-12 text-primary group-hover:text-primary/50 transition duration-300 ease-in-out"></GsIcon>
				</button>

				<div class="h-screen w-px bg-red-300 absolute z-20 left-1/2 -translate-x-1/2 hidden" aria-hidden="true"></div>
				<div class="w-screen h-px bg-red-300 absolute z-20 top-1/2 -translate-y-1/2 hidden" aria-hidden="true"></div>

				<div class="flex h-screen">
					<nav v-if="items?.length" role="navigation" class="
					m-auto lg:w-full!
					lg:translate-x-[9.25%]
					[@media(min-width:1281px)]:w-[95%]!
					[@media(min-width:1536px)]:w-[85%]!
					[@media(min-width:1820px)]:w-[72.5%]!
					[@media(min-width:1820px)]:translate-x-0
					[@media(min-width:1920px)]:w-[66%]!
					[@media(min-width:2100px)]:w-[63%]!
					[@media(min-width:2400px)]:w-55%]!
					[@media(min-width:3200px)]:w-[42.5%]!
					[@media(min-width:3800px)]:w-[35%]!
					[@media(min-width:4200px)]:w-[31%]!"
					>
						<div class="grid grid-cols-3">
							<div v-for="(item,idx) in items" :key="'onav-'+idx" class="flex">
								<div class="me-auto w-full">
									<NuxtLink v-if="item.name" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" class="text-[1.875rem] lg:text-[2rem] xl:text-[2.25rem] 2xl:text-[2.5rem] block mb-2.5 whitespace-nowrap text-primary hover:text-primary/80 transition duration-300 ease-in-out" :title="item.title" no-prefetch>
										{{ item.label }}
									</NuxtLink>
									<div class="border-s-5 border-primary ps-4 xl:ps-5 2xl:ps-5.5 ms-0.5">
										<ul v-if="item.children" class="space-y-6 xl:space-y-7 2xl:space-y-8">
											<li v-for="(subItem,idx) in item.children">
												<NuxtLink v-if="subItem.name" :to="{name: subItem.name, params: subItem.slug && subItem.name == 'article-detail' ? { article_slug: subItem.slug } : {}, query: subItem.query ? subItem.query : {} }" class="font-light leading-snug text-[1.25rem] lg:text-[1.375] xl:text-[1.45rem] 2xl:text-[1.5rem] whitespace-nowrap text-sand-50 hover:text-primary group transition duration-300 ease-in-out" :title="subItem.title" no-prefetch>
													{{ subItem.label }}
												</NuxtLink>
											</li>
										</ul>
										<ServiceAreaNavigationOverlayItems v-else-if="item.slug === 'leistungen'" />
									</div>
								</div>
							</div>
						</div>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>
